import { z } from "zod";

export enum NotificationRange {
  All = "all",
  Mention = "mention",
  None = "none",
}

export const NotificationRangeZod = z.enum(["all", "mention", "none"]);
